export default __webpack_public_path__ + "static/favicon-d7287b68d9e3ca61ada408bb8bc6b635.ico";